// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import App from './App'
import router from './router'
import store from '@/store'
import fastClick from 'fastClick'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Message from 'vue-m-message'
import VueSweetalert2 from 'vue-sweetalert2'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'swiper/css/swiper.css'

import {
  getUserInfo
} from '@/utils/user.js'

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(VueAwesomeSwiper)
Vue.use(Message)
Vue.use(VueSweetalert2)
Vue.use(ElementUI, { locale })

Vue.use(VueI18n)

//多语言支持
const i18n = new VueI18n({
  locale: store.state.config.lang,  // 语言标识
  messages: {
    'cn': require('@/lang/zh'),
    'en': require('@/lang/en')
  }
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

var docTitle = document.title;
router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title;
  }else{
    document.title = docTitle;
  }
  if(to.meta.loginRequired){
    if(store.getters['user/getToken'] && store.getters['user/getUserInfo']){
      next();
    }else{

      next('/login');
      /*if(confirm('请先登录再访问。去登录？')){
        next('/login');
      }else{
        window.history.back(-1);
        return;
      }*/
    }
  }
  next();
})

router.afterEach(function(to,from){
  //实现菜单导航，获取当前页面在那个菜单下
  localStorage.setItem('currMenu', to.meta.menuIndex);
})

/* eslint-disable no-new */
var vue = new Vue({
  el: '#AFCWAVE',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
export default vue;



// WEBPACK FOOTER //
// ./src/main.js